/* ============================================
   EBOOK DOWNLOAD MANAGER
   Gestiona la descarga del ebook para usuarios UNLIMITED
   Incluye rate limiting y control de descargas
   ============================================ */

// Configuración de límites
const DOWNLOAD_COOLDOWN = 5 * 60 * 1000; // 5 minutos entre descargas
const MAX_DOWNLOADS_PER_DAY = 3; // Máximo 3 descargas por día para UNLIMITED

// Función para verificar y actualizar límites de descarga
function checkDownloadLimits(userId) {
    const now = Date.now();
    const storageKey = `ebook_downloads_${userId}`;
    const data = JSON.parse(localStorage.getItem(storageKey) || '{"downloads": [], "lastDownload": 0}');
    
    // Limpiar descargas de hace más de 24 horas
    data.downloads = data.downloads.filter(timestamp => now - timestamp < 24 * 60 * 60 * 1000);
    
    // Verificar cooldown (tiempo desde última descarga)
    const timeSinceLastDownload = now - data.lastDownload;
    if (timeSinceLastDownload < DOWNLOAD_COOLDOWN) {
        const remainingMinutes = Math.ceil((DOWNLOAD_COOLDOWN - timeSinceLastDownload) / 60000);
        return {
            allowed: false,
            reason: 'cooldown',
            message: `⏱️ Espera ${remainingMinutes} minuto${remainingMinutes > 1 ? 's' : ''} antes de descargar de nuevo`,
            remainingTime: remainingMinutes
        };
    }
    
    // Verificar límite diario
    if (data.downloads.length >= MAX_DOWNLOADS_PER_DAY) {
        return {
            allowed: false,
            reason: 'daily_limit',
            message: `📊 Límite diario alcanzado (${MAX_DOWNLOADS_PER_DAY} descargas). Intenta mañana.`,
            downloadsToday: data.downloads.length
        };
    }
    
    // Actualizar datos
    data.downloads.push(now);
    data.lastDownload = now;
    localStorage.setItem(storageKey, JSON.stringify(data));
    
    return {
        allowed: true,
        downloadsToday: data.downloads.length,
        remainingDownloads: MAX_DOWNLOADS_PER_DAY - data.downloads.length
    };
}

// Función para descargar el ebook
window.downloadEbook = function() {
    if (window.demoGate && window.demoGate('ebook', 'Descargar eBook')) {
        return;
    }
    const userType = (localStorage.getItem('userType') || 'user').toLowerCase();
    const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase();
    const userId = sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId') || 'anonymous';
    
    // Debug: mostrar plan actual (comentar en producción)

    
    // Verificar acceso UNLIMITED o PRO (o admin)
    const hasAccess = userType === 'admin' || userPlan === 'unlimited' || userPlan === 'pro';
    
    if (!hasAccess) {
        if (window.showWarning && typeof window.showWarning === 'function') {
            window.showWarning('📚 Acceso Restringido', 'El eBook solo está disponible para usuarios UNLIMITED.\n\nUpgrade tu plan para acceder a contenido exclusivo.');
        } else if (window.showToast && typeof window.showToast === 'function') {
            window.showToast('📚 El eBook solo está disponible para usuarios UNLIMITED', 'warning', 3000);
        } else {

        }
        return;
    }
    
    // Verificar límites de descarga (excepto para admin)
    if (userType !== 'admin') {
        const limitCheck = checkDownloadLimits(userId);
        if (!limitCheck.allowed) {
            if (window.showWarning && typeof window.showWarning === 'function') {
                window.showWarning('Límite de Descargas', limitCheck.message);
            } else if (window.showToast && typeof window.showToast === 'function') {
                window.showToast(limitCheck.message, 'warning', 4000);
            } else {

            }
            return;
        }
        
        // Informar descargas restantes

    }
    
    // Iniciar descarga
    try {
        // Usar URL directa de R2
        const downloadUrl = 'https://pub-00e64b852dc04e3a8f102fa3d81f8bda.r2.dev/Ebook-Gestion-de-Riesgo-MDFX.pdf';
        
        // Mostrar confirmación ANTES de iniciar descarga
        if (window.showToast && typeof window.showToast === 'function') {
            window.showToast('📥 Descargando eBook...', 'info', 2000);
        }
        
        // Usar fetch + blob para forzar descarga (más confiable)
        fetch(downloadUrl, {
            mode: 'cors',
            credentials: 'omit'
        })
        .then(response => {
            if (!response.ok) throw new Error('Error al descargar');
            return response.blob();
        })
        .then(blob => {
            // Crear URL temporal del blob
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Ebook-Gestion-de-Riesgo-MDFX.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // Limpiar URL del blob después de un momento
            setTimeout(() => window.URL.revokeObjectURL(url), 100);
            
            // Notificación de éxito
            if (window.showToast && typeof window.showToast === 'function') {
                window.showToast('eBook descargado correctamente', 'success', 3000);
            }
            
            // Registrar descarga en base de datos (si está disponible)
            if (window.tursoClient && userId !== 'anonymous') {

                registerDownloadInDB(userId).catch(() => {});
            } else {
            }
        })
        .catch(error => {

            // Fallback: intentar abrir en nueva pestaña
            window.open(downloadUrl, '_blank');
            if (window.showToast && typeof window.showToast === 'function') {
                window.showToast('📖 Abriendo eBook en nueva pestaña...', 'info', 3000);
            }
        });
        
        // Analytics (opcional)
        if (typeof gtag !== 'undefined') {
            gtag('event', 'ebook_download', {
                'event_category': 'content',
                'event_label': 'Ebook Gestion de Riesgo',
                'value': 1
            });
        }
    } catch (error) {

        if (window.showToast && typeof window.showToast === 'function') {
            window.showToast('❌ Error al iniciar descarga. Intenta de nuevo.', 'error', 3000);
        }
    }
};

// Función para registrar descarga en base de datos
async function registerDownloadInDB(userId) {
    try {
        const client = window.tursoClient;
        if (!client) return;
        
        // Crear tabla si no existe (solo primera vez)
        await client.execute({
            sql: `CREATE TABLE IF NOT EXISTS ebook_downloads (
                id INTEGER PRIMARY KEY AUTOINCREMENT,
                user_id TEXT NOT NULL,
                ebook_name TEXT NOT NULL,
                downloaded_at TEXT NOT NULL,
                ip_hash TEXT,
                user_agent TEXT
            )`
        });
        
        // Registrar descarga
        await client.execute({
            sql: `INSERT INTO ebook_downloads (user_id, ebook_name, downloaded_at, user_agent) 
                  VALUES (?, ?, ?, ?)`,
            args: [
                userId,
                'Ebook-Gestion-de-Riesgo-MDFX',
                new Date().toISOString(),
                navigator.userAgent.substring(0, 255)
            ]
        });
        

    } catch (error) {

    }
}

// Inicializar visibilidad del botón de ebook
function initEbookButton() {
    const ebookBtn = document.getElementById('ebookBtn');
    if (!ebookBtn) return;
    
    const userType = localStorage.getItem('userType') || 'user';
    const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase();
    
    // EBOOK: Solo visible para UNLIMITED o admin
    const hasAccessToEbook = userType === 'admin' || userPlan === 'unlimited';
    ebookBtn.style.display = hasAccessToEbook ? 'inline-block' : 'none';
}

// Ejecutar al cargar el DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEbookButton);
} else {
    initEbookButton();
}

// Exponer función de inicialización para que pueda ser llamada desde otros scripts
window.initEbookButton = initEbookButton;
